import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";
import ApiService from "src/util/api.service";

export interface TachographCardClient {
  id?: string | number;
  name?: string;
  companyName?: string;
}

export type TachographCardStatus = 0 | 1 | 2 | 3 | 4;

export interface TachographCardRecord {
  cardId: string;
  externalId?: string | null;
  smartCardId?: string;
  reader?: string;
  changedTimestamp?: number;
  insertTimestamp?: number;
  position?: number | string;
  expireDate?: string | number;
  status?: TachographCardStatus | null;
  hardwareStatus?: TachographCardStatus | null;
  client?: TachographCardClient | null;
}

export interface TachographCardListParams {
  size: number;
  page: number;
  sort: "ASC" | "DESC";
  sortBy: string;
  distributorId?: string | number;
}

export interface TachographCardPaginatedResponse {
  resources?: TachographCardRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
  totalPages?: number;
  currentPage?: number;
}

export interface TachographCardListResponse {
  response?: TachographCardPaginatedResponse;
}

export interface TachographCardDetailResponse {
  response?: TachographCardRecord;
}

export interface TachographCardColumnsResponse {
  response?: unknown;
}

export interface CreateTachographCardPayload {
  smartCardId?: string;
  expireDate: number;
  customerId?: string | number;
}

export interface UpdateTachographCardPayload {
  cardId: string;
  customerId: string | number;
  smartCardId: string;
  expireDate: null;
}

export const getTachographCards = (params: TachographCardListParams, language?: string) =>
  ApiService.get<TachographCardListResponse>(ServicesUrlEndpoints.TACHOGRAPH_CARDS.LIST, {
    params,
    ...getLanguageHeaders(language),
  });

export const getTachographCardColumns = (language?: string) =>
  ApiService.get<TachographCardColumnsResponse>(
    ServicesUrlEndpoints.TACHOGRAPH_CARDS.COLUMNS,
    getLanguageHeaders(language)
  );

export const getTachographCardById = (id: string, language?: string) =>
  ApiService.get<TachographCardDetailResponse>(
    `${ServicesUrlEndpoints.TACHOGRAPH_CARDS.DETAIL}/${encodeURIComponent(id)}`,
    getLanguageHeaders(language)
  );

export const createTachographCard = (payload: CreateTachographCardPayload, language?: string) =>
  ApiService.post<TachographCardDetailResponse>(
    ServicesUrlEndpoints.TACHOGRAPH_CARDS.CREATE,
    payload,
    getLanguageHeaders(language)
  );

export const updateTachographCard = (payload: UpdateTachographCardPayload, language?: string) =>
  ApiService.post<TachographCardDetailResponse>(
    `${ServicesUrlEndpoints.TACHOGRAPH_CARDS.UPDATE}/${encodeURIComponent(payload.cardId)}`,
    {
      customerId: payload.customerId,
      smartCardId: payload.smartCardId,
      expireDate: payload.expireDate,
    },
    getLanguageHeaders(language)
  );

export const deleteTachographCard = (id: string, language?: string) =>
  ApiService.delete(
    `${ServicesUrlEndpoints.TACHOGRAPH_CARDS.DELETE}/${encodeURIComponent(id)}`,
    getLanguageHeaders(language)
  );
